export default __webpack_public_path__ + "static/media/Ass 10.d17d8ae7.png";